import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IUserSearchResult } from "../../models/User/User";
import { IDefaultResponse } from "../../models/DefaultResponse";

export const UserSearchQueryKeys = {
  search: (term: string) => ["users", "search", term],
};

/** Cross-customer user search (staff only), used to add an existing user to another customer. */
export default function useUserSearch(term: string) {
  const { get } = useApiHelper();
  const trimmed = term.trim();

  const results = useQuery({
    queryKey: UserSearchQueryKeys.search(trimmed),
    queryFn: () =>
      get<IDefaultResponse<IUserSearchResult[]>>(
        `/users/search?q=${encodeURIComponent(trimmed)}`,
      ).then((res) => res.data),
    enabled: trimmed.length >= 2,
  });

  return { results };
}
